// EL RELOJ DE CONTENCIÓN, EN COLORES Y EN PALABRAS · Fase 3.
//
// El semáforo lo calcula el servidor y llega en la respuesta; aquí solo
// se traduce a lo que ve una persona. Recalcularlo en el navegador daría
// dos versiones de la misma verdad, y la del navegador depende del reloj
// de un teléfono que puede estar mal.
import { ESTADO_POR_DEFECTO } from './estados';

export const SEMAFORO_RECLAMO = {
  A_TIEMPO: { etiqueta: 'A tiempo', color: 'verde' },
  POR_VENCER: { etiqueta: 'Por vencer', color: 'ambar' },
  VENCIDO: { etiqueta: 'Sin contener', color: 'rojo' },
  CONTENIDO: { etiqueta: 'Contenido', color: 'verde' },
  // CONTENIDO TARDE NO ES VERDE, y tampoco rojo. Se hizo el trabajo,
  // fuera de plazo: pintarlo verde escondería lo que el cliente ya sabe.
  CONTENIDO_TARDE: { etiqueta: 'Contenido tarde', color: 'ambar' },
};

export function semaforoReclamo(clave) {
  return SEMAFORO_RECLAMO[clave] || ESTADO_POR_DEFECTO;
}

/** Qué hay que hacer con este reclamo, en una frase. */
export function queHacer(fila) {
  switch (fila?.semaforo) {
    case 'VENCIDO':
      return 'El plazo ya pasó y no hay contención registrada. Regístrala '
        + 'aunque sea tarde: queda apuntado que fue fuera de plazo, y eso '
        + 'es mejor que no tener nada que enseñar.';
    case 'POR_VENCER':
      return 'Queda poco. Revisa lo que va en camino, aparta lo que quede '
        + 'en almacén y regístralo.';
    case 'A_TIEMPO':
      return 'Todavía hay tiempo, pero la contención es lo primero que '
        + 'pregunta un cliente.';
    case 'CONTENIDO_TARDE':
      return 'Se contuvo fuera de plazo. Lo que sigue es el análisis 8D.';
    case 'CONTENIDO':
      return 'Contención registrada a tiempo. Lo que sigue es el 8D.';
    default:
      return '';
  }
}

// CÓMO SE LEE UN PPM, para que el número no se quede solo.
//
// Un PPM sin referencia no dice nada: 2 500 puede ser excelente o
// catastrófico según el sector. Estos tramos son los que se usan en
// automotriz, que es de donde vienen los clientes de TEGO.
export function comoVaElPPM(ppm) {
  if (ppm === null || ppm === undefined) {
    return { etiqueta: 'Sin embarques', color: 'gris',
             nota: 'Todavía no se le ha embarcado nada en este periodo, así '
                 + 'que no hay entre qué dividir.' };
  }
  if (ppm === 0) {
    return { etiqueta: 'Cero rechazos', color: 'verde',
             nota: 'No hubo reclamos de este cliente en el periodo.' };
  }
  if (ppm <= 50) return { etiqueta: 'Bien', color: 'verde', nota: '' };
  if (ppm <= 500) return { etiqueta: 'Vigílalo', color: 'ambar', nota: '' };
  return { etiqueta: 'Alto', color: 'rojo',
           nota: 'A partir de aquí, prepara un plan de acción por escrito: '
               + 'es lo que pide un cliente industrial.' };
}
